export const DEFAULT_BLOG_ID = {
  en: {
    default: 89,
    pasword_manager: 92,
    secret_manager: 93,
  },
  vi: {
    default: 88,
    pasword_manager: 90,
    secret_manager: 91,
  },
}

export const DEFAULT_PASSWORD_NOTION_TABLE = '94a24472-7185-418f-80c4-764a7d43a253'

export const PASSWORD_GENERATOR_ALIAS = [
  'with-symbols',
  'alphanumeric',
  'with-uppercase',
  'with-lowercase',
  'mixed-case',
  'numeric',
  'pin-code',
  'brute-force-resistance',
  'memorable',
]

export const LOCKER_GITHUB = 'https://github.com/lockerpm'
export const PASSWORD_PURCHASE = 'https://locker.io/passwords/purchase'
export const LOCKER_CONTACT = 'https://locker.io/contact'
export const LOCKER_CONTACT_VI = 'https://locker.io/vi/contact'
export const ENTERPRISE_LOCKER_PURCHASE = 'https://enterprise.locker.io/purchase'
export const PASSWORD_BUSINESS_REGISTER = 'https://locker.io/passwords/business/register'
export const PASSWORD_BUSINESS_REGISTER_VI = 'https://locker.io/vi/passwords/business/register'
export const LIFETIME_URL = 'https://locker.io/passwords/lifetime/team'

export const postDetailDescriptionRegex =
  /<meta[^>]+name=["']description["'][^>]+content=["']([^"']+)["']/i
export const postDetailOgDescriptionRegex =
  /<meta[^>]+property=["']og:description["'][^>]+content=["']([^"']+)["']/i

export const postDetailTitleRegex = /<meta[^>]+name=["']title["'][^>]+content=["']([^"']+)["']/i
export const postDetailPageTitleRegex = /<title>([^<]+)<\/title>/i
export const postDetailOgTitleRegex =
  /<meta[^>]+property=["']og:title["'][^>]+content=["']([^"']+)["']/i
